module.exports = __webpack_public_path__ + "img/jg.28abfc8e.jpg";